import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'sn-sort-button',
  templateUrl: './sort-button.component.html',
  styleUrls: ['./sort-button.component.scss'],
})
export class SortButtonComponent implements OnInit {
  @Input() value: 'asc' | 'desc';
  @Input() disabled: boolean = false;

  @Output() sortChange = new EventEmitter<any>();

  // ascending / descending icons
  public sortAscendingIcon: string = './assets/fusus-icons/SVG/sortAscending.svg';
  public sortDescendingIcon: string = './assets/fusus-icons/SVG/sortDescending.svg';

  constructor() {}
  /** sort-button is initialized. Default value is ascending */
  public ngOnInit(): void {}

  //** this function will emit a value of either ascending or descending order. */
  onSortChange(): void {
    if (this.disabled) {
      return;
    }
    this.value = this.value === 'asc' ? 'desc' : 'asc';
    this.sortChange.emit(this.value);
  }
}
